/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createFineStructure } from '../../factoriesAny.js';
export var fineStructureDependencies = {
  BigNumberDependencies,
  createFineStructure
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesFineStructure.generated.js
// module id = 0Mal
// module chunks = 3